import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-task-comment-icon',
  template: `
    @if (tooltip) {
      <bl-frontend-tooltip [content]="tooltip">
        <bl-frontend-icon
          name="info-circle"
          color="info"
          [ariaLabel]="tooltip"
          [ngClass]="classIfVisible"></bl-frontend-icon>
      </bl-frontend-tooltip>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'cursor-pointer' },
})
export class TaskCommentIconComponent {
  @Input() tooltip: string;
  @Input() classIfVisible: string;
}
